/*-------------------------------------------------------------------
グローバル変数
--------------------------------------------------------------------*/
let headerHeight;

/*-------------------------------------------------------------------
関数定義
--------------------------------------------------------------------*/
function isPc() {
  return window.innerWidth >= 768;
}
// Mobileの場合True
function isMobile() {
  return !isPc();
}

/**
 * 指定の要素のテキストを1文字ずつspanで囲む
 */
const wrapSpan = () => {
  const textWrap = document.querySelectorAll('.js-wrapSpan');
  textWrap.forEach((t) => (t.innerHTML = t.textContent.replace(/\S/g, '<span>$&</span>')));
};

/**
 * スムーススクロール共通処理
 * @param {string} targetId - スクロール先のセレクタ
 * @param {number} speed - アニメーション速度（デフォルト: 500）
 * @param {number} offset - オフセット値（デフォルト: headerHeight）
 * @param {function} onComplete - アニメーション完了時のコールバック（任意）
 */
function smoothScrollTo(targetId, speed = 500, offset = null, onComplete = null) {
  const target = jQuery(targetId);
  if (!target.length) return;

  let position = target.offset().top;
  const adjustOffset = offset !== null ? offset : headerHeight;

  // ヘッダーの固定状態に応じて位置を調整
  if ('fixed' === jQuery('#header').css('position') || 'sticky' === jQuery('#header').css('position')) {
    position -= adjustOffset;
  }

  // 負の値にならないようにする
  if (position < 0) {
    position = 0;
  }

  jQuery('html, body').animate({ scrollTop: position }, speed, function () {
    if (typeof onComplete === 'function') onComplete();
  });
}

/**
 * アンカーリンク
 */
function scrollHash() {
  const hash = location.hash;
  if (hash && jQuery(hash).length) {
    // 一旦トップに戻してから目的地にスクロール
    window.scrollTo(0, 0);
    setTimeout(() => {
      smoothScrollTo(hash, 500, null, () => {
        // ページ内遷移後に ScrollTrigger のトリガー位置を再計算（スマホでずれ防止）
        if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
      });
    }, 300);
  }
}

// /**
//  * ローディング画面
//  */
// function stopload() {
//   jQuery('#js-loading').delay(900).fadeOut(800);
// }

/*-------------------------------------------------------------------
読み込み時実行
--------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
  headerHeight = document.querySelector('.js-header').offsetHeight;
  // wrapSpan();
  // setTimeout('stopload()', 10000);
});

/*-------------------------------------------------------------------
イベント
--------------------------------------------------------------------*/
/**
 * スクロールバーを除いた画面幅の取得
 */
jQuery(window).on('load resize', function () {
  let vw = document.body.clientWidth; // スクロールバーを除いた幅を取得
  let vh = window.innerHeight; // アドレスバーを覗いた画面高さ
  headerHeight = document.querySelector('.js-header').offsetHeight;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vw-unitless', `${vw}`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
});

// ローディング判定
jQuery(window).on('load', function () {
  jQuery('body').attr('data-loading', 'true');
  // stopload();
});

/**
 * フェードしたページに戻るときに白飛びする対応
 */
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});

jQuery(function () {
  // ページロード完了後にスクロールハッシュを実行
  jQuery(window).on('load', function () {
    scrollHash();
  });
  // gsap.to('body', { opacity: 1, duration: 0.5 });

  // 画面遷移
  window.addEventListener('beforeunload', function (e) {
    document.body.classList.add('fadeOut');
    setTimeout(() => {
      window.location = url;
    }, 500);
  });

  // スクロール判定
  jQuery(window).on('scroll', function () {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let documentHeight = jQuery(document).height();

    if (100 < scrollTop) {
      jQuery('body').attr('data-scroll', 'true');
    } else {
      jQuery('body').attr('data-scroll', 'false');
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery('body').attr('data-scroll-bottom', 'true');
    } else {
      jQuery('body').attr('data-scroll-bottom', 'false');
    }

    /**
     * トップに戻るボタン
     */
    const totop = jQuery('.js-totop');
    const totopTarget = jQuery(`.${totop.data('target')}`);
    if ((totopTarget.length ? totopTarget.innerHeight() : headerHeight) < scrollTop) {
      totop.addClass('is-active');
    } else {
      totop.removeClass('is-active');
    }
  });

  /* PCヘッダー: SERVICEサブメニュー開閉 */
  jQuery('.js-nav-service').on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    const btn = jQuery(this);
    const sublist = btn.siblings('.p-header__nav-sublist');
    const sublinks = sublist.find('.p-header__nav-sublink');
    const isOpen = sublist.hasClass('is-show');

    //他の開いているサブメニューを閉じる
    jQuery('.p-header__nav-sublist.is-show').not(sublist).each(function () {
      jQuery(this).removeClass('is-show');
      jQuery(this).attr('aria-hidden', 'true');
      jQuery(this).find('.p-header__nav-sublink').attr('tabindex', '-1');
      jQuery(this).siblings('.js-nav-service').attr('aria-expanded', 'false');
    });

    if (isOpen) {
      sublist.removeClass('is-show');
      sublist.attr('aria-hidden', 'true');
      sublinks.attr('tabindex', '-1');
    } else {
      sublist.addClass('is-show');
      sublist.attr('aria-hidden', 'false');
      sublinks.removeAttr('tabindex');
    }
    btn.attr('aria-expanded', !isOpen);
  });

  jQuery(document).on('click', function (event) {
    jQuery('.js-nav-dropdown').each(function () {
      if (!this.contains(event.target)) {
        const sublist = jQuery(this).find('.p-header__nav-sublist');
        if (sublist.hasClass('is-show')) {
          sublist.removeClass('is-show');
          sublist.attr('aria-hidden', 'true');
          sublist.find('.p-header__nav-sublink').attr('tabindex', '-1');
          jQuery(this).find('.js-nav-service').attr('aria-expanded', 'false');
        }
      }
    });
  });

  /* ドロワー */
  jQuery('.js-drawer').on('click', function (event) {
    event.preventDefault();
    const ariaControls = jQuery(this).attr('aria-controls');
    const addClass = 'is-opened';

    if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
      jQuery(`#${ariaControls}`).removeClass(addClass);
    } else {
      jQuery(`#${ariaControls}`).addClass(addClass);
    }

    jQuery(`[aria-controls=${ariaControls}]`).each(function () {
      jQuery(this).attr('aria-expanded', jQuery(`#${ariaControls}`).hasClass(addClass) ? 'false' : 'true');
      if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
        jQuery(this).addClass(addClass);
      } else {
        jQuery(this).removeClass(addClass);
      }
    });

    // ドロワー開時にbody要素がスクロールしないように
    jQuery(`#${ariaControls}`).hasClass(addClass)
      ? jQuery('body').addClass('u-overflowHidden')
      : jQuery('body').removeClass('u-overflowHidden');

    return false;
  });

  /**
   * ドロワー内のページ内リンククリック時に閉じる
   */
  jQuery('#drawer-content1 a[href*="#"]').on('click', function (event) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname; // 現在のURL
    const href = jQuery(this).prop('href');
    const hrefUrl = href.split('#')[0]; // リンク先のURL

    if (currentUrl == hrefUrl) {
      jQuery('.for-drawer').removeClass('is-opened');
      jQuery('#drawer-content1').attr('aria-hidden', true);
      jQuery('body').removeClass('u-overflowHidden');
    }
  });

  /* スムーススクロール */
  jQuery(document).on(
    'click',
    'a[href*="#"]:not(".js-tabIndex, .js-modal, .js-accordion, .toc_toggle a")',
    function (e) {
      const currentUrl = location.protocol + '//' + location.host + location.pathname.replace(/\/$/, ''); // 現在のURL
      const href = jQuery(this).prop('href');
      const hrefUrl = href.split('#')[0].replace(/\/$/, ''); // リンク先のURL

      if (currentUrl == hrefUrl) {
        e.preventDefault();
        let id = '#' + href.split('#')[1]; // リンク先のアンカー
        const targetId = '#' === id ? 'html' : id;
        smoothScrollTo(targetId, 500, null, () => {
          if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
        });
        jQuery(this).blur();
      }
    },
  );

  /* 電話リンク */
  let $ua = navigator.userAgent;
  if ($ua.indexOf('iPhone') < 0 && $ua.indexOf('Android') < 0) {
    // PCのとき
    jQuery('a[href^="tel:"]') // 電話リンク
      .css('cursor', 'default') // カーソルをポインターにしない
      .css('pointer-events', 'none') // ホバーなども動作しない
      .on('click', function (e) {
        e.preventDefault();
      });
  }

  /* tab */
  jQuery('.js-tabIndex').on('click', function (e) {
    e.preventDefault();
    const tabParent = jQuery(this).parents('.js-tab');
    const targets = jQuery(this).data('target');
    const target = jQuery(this).attr('href');

    jQuery('.js-tabIndex.is-active').removeClass('is-active');
    jQuery(this).addClass('is-active');

    // 現在表示しているものを非表示にする
    tabParent.find(`.${targets}.is-active`).removeClass('is-active');
    // クリックしたタブのターゲットを表示
    jQuery(target).addClass('is-active');

    return false;
  });
});

// FVスライダー
jQuery(function ($) {
  var swiper = new Swiper('.js-slider--fv', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 3000,
    allowTouchMove: false, // スワイプ無効
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    disableOnInteraction: false,
    loopAdditionalSlides: 1,
    centeredSlides: true,
    // 前後の矢印
    // navigation: {
    //     nextEl: '.js-bannerNext',
    //     prevEl: '.js-bannerPrev',
    // },
    // pagination: {
    //     el: ".p-slider__pagination",
    //     clickable: true,
    // },
  });
});

// Serviceスライダー
jQuery(function ($) {
  var swiper = new Swiper('.js-slider--service', {
    loop: true,
    effect: 'slide',
    speed: 1000,
    allowTouchMove: true, // スワイプ無効
    slidesPerView: 1,
    disableOnInteraction: false,
    loopAdditionalSlides: 1,
    centeredSlides: true,
    // 前後の矢印
    navigation: {
      nextEl: '.js-bannerNext',
      prevEl: '.js-bannerPrev',
    },
    // pagination: {
    //     el: ".p-slider__pagination",
    //     clickable: true,
    // },
  });
});

// サービスページFVスライダー（トップの.js-slider--fvと競合しないよう別クラスで初期化）
jQuery(function ($) {
  var $el = $('.js-slider--service-fv');
  if ($el.length === 0) return;
  new Swiper('.js-slider--service-fv', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 3000,
    allowTouchMove: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    disableOnInteraction: false,
    loopAdditionalSlides: 1,
    centeredSlides: true,
  });
});
